import { kebabCase } from 'lodash';
import { getSummary } from '@/pages/CompanyReport/redux/selectors';
import { useSelector } from 'react-redux';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

const useScreenerLinkInfo = () => {
  const reduxSummary = useSelector((state) => getSummary(state, {}));
  const market =
    reduxSummary.countryISO.toLowerCase() as PrimaryCountryISOElseGlobal;
  const industry = kebabCase(reduxSummary.industryData.primaryName);

  return {
    market,
    industry,
  };
};

export default useScreenerLinkInfo;
